module.exports = __webpack_public_path__ + "static/media/Instagram.11a28ee0.svg";